import React from 'react';
import { FormControl, FormGroup, FormLabel } from 'react-bootstrap';

interface ITextInput
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  label?: string;
  error?: string;
}

function TextInput(props: ITextInput) {
  const { label, ...rest } = props;
  const defaultCls = props.error ? 'form-control is-invalid' : 'form-control';
  if (label) {
    return (
      <FormGroup>
        <FormLabel htmlFor={rest.id}>{label}</FormLabel>
        <input className={defaultCls} {...rest} />
        <FormControl.Feedback
          type='invalid'
          className={props.error ? 'd-block' : undefined}
        >
          {props.error}
        </FormControl.Feedback>
      </FormGroup>
    );
  } else {
    return (
      <>
        <input className={defaultCls} {...rest} />
        <FormControl.Feedback
          type='invalid'
          className={props.error ? 'd-block' : undefined}
        >
          {props.error}
        </FormControl.Feedback>
      </>
    );
  }
}

export default TextInput;
